import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProject(request: Boundaries["editProject"]["request"]): void;
}

function useProjectEdition(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isProjectEditionRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isProjectEditionRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isProjectEditionRequestFailure(project),
    ),
    editProject: core.editProject,
  };
}

export { useProjectEdition };
